import config from '../../legacy/customer/allianz/configuration';
import { Configuration } from '../type/configuration';

export default config as Configuration;